// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import { request } from '@mairistem/tools';
import _ from 'lodash';
import * as React from 'react';
import { Route, Router } from 'react-router-dom';
import RegisseurContextProvider from '@/components/Context/RegisseurContextProvider';
import { useUtilisateurStore } from '@/zustand';
import {
  ArreteAnnuelAgentGuard,
  ArreteAnnuelAutomatiqueCreator,
  ArreteAnnuelProcedureCreator,
  ArreteAutomatiqueCreator,
  ArreteComptableGuard,
} from '../Arrete';
import { InterrogationPaiementsMFO, ModalToastContainer, RegieInitializer } from '../Autre';
import EncaissementDirectGuard from '../EncaissementDirect/EncaissementDirectGuard';
import MenuVisibilityController from '../MenuVisibility';
import { RegisseurRouter } from '../Regisseur';
import EmbeddedHandler from './EmbeddedHandler';
import RegieContextProvider from './RegieContextProvider';

const Context = (p) => {
  const { children, path, scope, history, user: userFromProps } = p;

  // Fallback: récupérer user depuis sessionStorage si non fourni via props (mode standalone)
  const user = React.useMemo(() => {
    if (userFromProps) return userFromProps; // Mode Shell

    // Mode standalone: récupérer depuis sessionStorage
    const storedUser = sessionStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  }, [userFromProps]);

  const setUtilisateur = useUtilisateurStore((state) => state.setUtilisateur);
  const utilisateur = useUtilisateurStore((state) => state.utilisateur);

  React.useEffect(() => {
    if (_.isNil(utilisateur)) {
      setUtilisateur(user);
    }

    const interceptor = request.interceptors.request.use((config) => {
      // En dèv on simule le fait que l'utilisateur avec id_login = 1 soit connecté
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        config.headers['X-Login'] = 1;
      }
      return config;
    });

    return () => {
      request.interceptors.request.eject(interceptor);
    };
  }, [setUtilisateur, user, utilisateur]);

  return (
    <Router history={history}>
      <ModalToastContainer />
      <EncaissementDirectGuard />
      <Route path={path}>
        {scope === 'content' ? (
          <RegieInitializer>
            <EmbeddedHandler>
              <RegieContextProvider>
                <RegisseurContextProvider>
                  <ArreteComptableGuard>
                    <MenuVisibilityController />
                    <ArreteAutomatiqueCreator />
                    <InterrogationPaiementsMFO />
                    <ArreteAnnuelAutomatiqueCreator />
                    <ArreteAnnuelProcedureCreator />
                    <ArreteAnnuelAgentGuard />
                    <RegisseurRouter>
                      {React.isValidElement(children) ? children : React.createElement(children)}
                    </RegisseurRouter>
                  </ArreteComptableGuard>
                </RegisseurContextProvider>
              </RegieContextProvider>
            </EmbeddedHandler>
          </RegieInitializer>
        ) : React.isValidElement(children) ? (
          children
        ) : (
          React.createElement(children)
        )}
      </Route>
    </Router>
  );
};

export default Context;
